/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { useState } from 'react';
// material
import { SingleSelectDropDown } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/controlbar/contentsort/contentsort_styles';



/* ========== ~~~~~~~~~~ CONTENT SORT  : CHILD ~~~~~~~~~~ ========== */
const ContentSort = ({classes, sort}) => {
    const [selected, setSelected] = useState({name: 'As in embed', value: 'QUEUE_POSITION', dir: 'ASC'});
    const sortableOptions =
        [{name: 'As in embed', value: 'QUEUE_POSITION', dir: 'ASC'},
            {name: 'Date created (newest)', value: 'CREATED_AT', dir: 'DESC'},
            {name: 'Date created (oldest)', value: 'CREATED_AT', dir: 'ASC'},
            {name: 'Engagement', value: 'ENGAGEMENT', dir: 'DESC'}];

    const handleSelect = sortBy => {
        setSelected(sortBy);
        sort(sortBy)
    };
    return <SingleSelectDropDown
                klass={`contentsort ${classes.contentsort}`}
                onSelect={handleSelect}
                disabled={false}
                selected={selected}
                searchable={false}
                name={`Sort content`}
                items={sortableOptions}
            />
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ContentSort);
